<template>
  <div class="regra-negocio-promocao">
    <div class="regra-negocio-promocao__titulo">
      <strong>{{ item.id }} - {{ item.descricao }}</strong>
      <span v-if="item.situacao" class="regra-negocio-promocao__situacao">{{ item.situacao }}</span>
    </div>
    <div class="regra-negocio-promocao__detalhes">
      <span>Desconto: {{ item.perc_desconto || "n/d" }}</span>
      <span>Preço promoção: {{ item.preco_promocional || "n/d" }}</span>
      <span>Cliente: {{ item.cliente_id || "*" }}</span>
      <span>Filial: {{ item.filial_id || "*" }}</span>
      <span>{{ item.data_inicio || "…" }} a {{ item.data_fim || "…" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "itemPromocao",
  props: ["item"],
};
</script>

<style scoped>
.regra-negocio-promocao {
  min-width: 0;
  font-size: 12.5px;
  color: #344054;
}

.regra-negocio-promocao__titulo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  word-break: break-word;
}

.regra-negocio-promocao__situacao {
  padding: 0 6px;
  border-radius: 4px;
  background-color: #f2f4f7;
  font-size: 10.5px;
  font-weight: 600;
  color: #475467;
}

.regra-negocio-promocao__detalhes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 2px;
  font-size: 11.5px;
  color: #667085;
}
</style>
